/**
 * Usuário precisa aceitar Termos/Privacidade vigentes antes de usar o app.
 * Fail-safe: só libera com aceite_ok === true e lista de pendentes vazia.
 */
export function precisaAceiteLegal(user) {
  if (!user) return false;
  const pendentes = Array.isArray(user.legal_aceite_pendente) ? user.legal_aceite_pendente : [];
  if (pendentes.length > 0) return true;
  return user.legal_aceite_ok !== true;
}

/** Mescla auth/user + /legal/meu-status/ com regra fail-closed. */
export function mesclarStatusLegal(userData, legalStatus) {
  const pendentesApi = Array.isArray(legalStatus?.pendentes) ? legalStatus.pendentes : [];
  const pendentesUser = Array.isArray(userData?.legal_aceite_pendente) ? userData.legal_aceite_pendente : [];
  const pendentes = pendentesApi.length > 0 ? pendentesApi : pendentesUser;
  const aceiteOk = pendentes.length === 0 && legalStatus?.aceite_ok === true;

  return {
    ...userData,
    legal_aceite_ok: aceiteOk,
    legal_aceite_pendente: pendentes,
  };
}

/**
 * Destino interno pendente salvo antes do login (ex.: link de convite clicado
 * por quem não estava logado). Só aceita caminhos internos simples.
 */
function destinoPendente() {
  let alvo = null;
  try {
    const token = sessionStorage.getItem('convite_pendente');
    if (token) alvo = `/convite/${encodeURIComponent(token)}`;
    if (!alvo) alvo = sessionStorage.getItem('redirect_apos_login');
  } catch {
    return null;
  }
  if (!alvo || typeof alvo !== 'string') return null;
  if (!alvo.startsWith('/') || alvo.startsWith('//')) return null;
  return alvo;
}

function limparDestinoPendente() {
  try {
    sessionStorage.removeItem('convite_pendente');
    sessionStorage.removeItem('redirect_apos_login');
  } catch { /* ignore */ }
}

export function rotaAposLogin(user) {
  if (precisaAceiteLegal(user)) return '/aceitar-termos';
  return destinoPendente() || '/meu-desempenho';
}

export function irAposLogin(user, navigate) {
  const pendente = destinoPendente();

  if (precisaAceiteLegal(user)) {
    sessionStorage.setItem('legal_gate_required', '1');
    // Depois de aceitar os termos, a AceitarTermosPage volta para cá.
    if (pendente) sessionStorage.setItem('legal_redirect_after', pendente);
    // A conta nova via Google cai aqui logo após disparar o CompleteRegistration;
    // a espera dá tempo de o Pixel e o GA4 enviarem o evento antes da recarga.
    setTimeout(() => window.location.assign('/aceitar-termos'), 500);
    return;
  }

  sessionStorage.removeItem('legal_gate_required');
  if (pendente) {
    limparDestinoPendente();
    navigate(pendente);
    return;
  }
  navigate('/meu-desempenho');
}
